import { RESET, SET, SET_CARD } from './constants';

export const resetCustomer = () => ({
  type: RESET,
});

export const setCustomer = (customer, defaultCardId = null) => ({
  type: SET,
  payload: customer,
  customPaymentCardId: defaultCardId, // default card id is used to override the card that would be used by default
});

export const setCard = card => ({
  type: SET_CARD,
  payload: card,
});
